export default function (callback) {
    return () => {
      // 下拉加载
      const pageHeight = Math.max(
        document.body.scrollHeight,
        document.body.offsetHeight
      );
      const viewportHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight ||
        0;
      const scrollHeight =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      if (pageHeight - viewportHeight - scrollHeight < 20) {
        callback && callback();
      }
    };
  }
  